import NavigationListItem from "@components/side-navbar/NavigationListItem";
import { Question } from "@piiqtechnologies/svg-icons";
import React from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
export const HelpDesk = ({ expanded }) => {
    const intl = useIntl();
    const handleHelpDeskClick = () => {
        window.open("https://piiq.atlassian.net/servicedesk/customer/portals", "_blank", "noopener,noreferrer");
    };
    return (React.createElement(NavigationListItem, { Icon: () => React.createElement(Question, { width: "24px", height: "24px" }), label: intl.formatMessage(messages.helpDesk), expanded: expanded, active: false, onClick: handleHelpDeskClick }));
};
export default HelpDesk;
